import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { TrendingUp, TrendingDown, Building2, BarChart3, DollarSign, Calendar, Info } from 'lucide-react';
import { formatMarketCap, formatVolume } from './formatters';

const MetricBox = ({ Icon, label, value, color }) => (
  <div className={`p-4 bg-${color}-50 rounded-lg`}>
    <div className="flex items-center gap-2 mb-2">
      <Icon size={20} className={`text-${color}-600`} />
      <p className="text-sm text-gray-600">{label}</p>
    </div>
    <p className="text-xl font-bold text-gray-900">{value}</p>
  </div>
);

const StockHeaderCard = ({ stockData }) => (
  <Card>
    <CardContent className="pt-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">{stockData.symbol}</h2>
          <p className="text-lg text-gray-600 mt-1">{stockData.name}</p>
        </div>
        <div className="text-right">
          <p className="text-4xl font-bold text-gray-900">${stockData.price.toFixed(2)}</p>
          <div className="flex items-center gap-2 justify-end mt-2">
            {stockData.change >= 0 ? (
              <TrendingUp className="text-green-600" size={24} />
            ) : (
              <TrendingDown className="text-red-600" size={24} />
            )}
            <span
              className={`text-xl font-semibold ${
                stockData.change >= 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {stockData.change >= 0 ? '+' : ''}
              {stockData.change.toFixed(2)} ({stockData.changePercent >= 0 ? '+' : ''}
              {stockData.changePercent.toFixed(2)}%)
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <MetricBox Icon={Building2} label="Market Cap" value={formatMarketCap(stockData.marketCap)} color="purple" />
        <MetricBox Icon={BarChart3} label="P/E Ratio" value={stockData.peRatio ? stockData.peRatio.toFixed(2) : 'N/A'} color="blue" />
        <MetricBox Icon={DollarSign} label="Volume" value={formatVolume(stockData.volume)} color="green" />
        <MetricBox Icon={Calendar} label="Avg Volume" value={formatVolume(stockData.avgVolume)} color="orange" />
      </div>

      <div className="mt-4 flex items-start gap-2 text-xs text-gray-500">
        <Info size={14} className="mt-0.5 text-gray-400" />
        <p>
          Price, volume, and market-cap data are sourced from Yahoo Finance via yfinance. Values are for informational
          purposes only and may be delayed or incomplete. Always confirm prices and fundamentals with your broker
          before trading.
        </p>
      </div>
    </CardContent>
  </Card>
);

export default StockHeaderCard;
